/* Bold Uniq — theme.js — vanilla, no framework */
(() => {
  'use strict';

  /* ── Mobile hamburger nav ─────────────────────────────────── */
  const mobileNav     = document.getElementById('bu-mobile-nav');
  const hamBtn        = document.querySelector('[data-bu-ham]');
  const hamClose      = document.querySelector('[data-bu-ham-close]');
  const hamOverlay    = document.querySelector('[data-bu-ham-overlay]');

  const openMobileNav = () => {
    if (!mobileNav) return;
    mobileNav.dataset.open = 'true';
    if (hamOverlay) hamOverlay.dataset.open = 'true';
    if (hamBtn) hamBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    hamClose?.focus();
  };
  const closeMobileNav = () => {
    if (!mobileNav) return;
    mobileNav.dataset.open = 'false';
    if (hamOverlay) hamOverlay.dataset.open = 'false';
    if (hamBtn) hamBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamBtn?.focus();
  };

  hamBtn?.addEventListener('click', openMobileNav);
  hamClose?.addEventListener('click', closeMobileNav);
  hamOverlay?.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav?.dataset.open === 'true') closeMobileNav();
  });

  /* Reveal on scroll */
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) {
      e.target.classList.add('bu-reveal--visible');
      io.unobserve(e.target);
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.bu-reveal').forEach(el => io.observe(el));

  /* Header sticky shadow */
  const header = document.querySelector('.bu-header');
  if (header) {
    let t; window.addEventListener('scroll', () => {
      if (t) return;
      t = requestAnimationFrame(() => {
        header.classList.toggle('bu-header--scrolled', window.scrollY > 40);
        t = null;
      });
    }, { passive: true });
  }

  /* Accordion */
  document.querySelectorAll('[data-bu-accordion]').forEach(root => {
    root.querySelectorAll('[data-bu-accordion-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (root.dataset.buAccordion === 'single') {
          root.querySelectorAll('[data-bu-accordion-trigger]').forEach(t => {
            t.setAttribute('aria-expanded', 'false');
            const p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          });
        }
        trigger.setAttribute('aria-expanded', String(!isOpen));
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (panel) panel.hidden = isOpen;
      });
    });
  });

  /* Gallery swap */
  document.querySelectorAll('[data-bu-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-bu-gallery-main]');
    gallery.querySelectorAll('[data-bu-gallery-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-bu-gallery-thumb]').forEach(t => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
        const src = thumb.dataset.src || thumb.querySelector('img')?.src;
        const img = main?.querySelector('img');
        if (src && img) img.src = src;
      });
    });
  });

  /* Size selector */
  document.querySelectorAll('[data-bu-size-selector]').forEach(group => {
    const hidden = group.querySelector('input[type="hidden"]');
    const buttons = group.querySelectorAll('[role="radio"]');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        if (hidden) hidden.value = btn.dataset.variantId;
        const price = document.querySelector('[data-bu-buybox-price]');
        if (price && btn.dataset.price) price.textContent = btn.dataset.price;
      });
    });
  });

  /* Qty stepper */
  document.querySelectorAll('[data-bu-qty-stepper]').forEach(stepper => {
    const input = stepper.querySelector('input[name="quantity"]');
    const valueEl = stepper.querySelector('[data-bu-qty-value]');
    const min = parseInt(stepper.dataset.min || '1', 10);
    const max = parseInt(stepper.dataset.max || '99', 10);
    stepper.querySelector('[data-bu-qty-dec]')?.addEventListener('click', () => {
      const v = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
      input.value = v; if (valueEl) valueEl.textContent = v;
    });
    stepper.querySelector('[data-bu-qty-inc]')?.addEventListener('click', () => {
      const v = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
      input.value = v; if (valueEl) valueEl.textContent = v;
    });
  });

  /* Subscribe toggle */
  document.querySelectorAll('[data-bu-subscribe-toggle]').forEach(t => {
    const cb = t.querySelector('input[type="checkbox"]');
    const update = () => { t.dataset.checked = String(cb.checked); };
    t.addEventListener('click', (e) => {
      if (e.target !== cb) cb.checked = !cb.checked;
      update();
    });
    update();
  });

  /* Cart drawer */
  const drawer  = document.getElementById('bu-cart-drawer');
  const overlay = document.getElementById('bu-cart-drawer-overlay');
  const openDrawer = () => {
    if (!drawer) { window.location.href = '/cart'; return; }
    drawer.dataset.open = 'true';
    if (overlay) overlay.dataset.open = 'true';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-bu-cart-close]')?.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.dataset.open = 'false';
    if (overlay) overlay.dataset.open = 'false';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  document.querySelectorAll('[data-bu-cart-open]').forEach(b => {
    b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-bu-cart-close]').forEach(b => {
    b.addEventListener('click', closeDrawer);
  });
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer?.dataset.open === 'true') closeDrawer(); });

  /* Product form ajax → cart */
  document.querySelectorAll('form[data-bu-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: new FormData(form),
          headers: { 'Accept': 'application/json' },
        });
        if (!res.ok) throw new Error();
        await refreshCartUI();
        openDrawer();
      } catch (err) {
        window.location = '/cart';
      } finally { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } }
    });
  });

  async function refreshCartUI() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-bu-cart-count]').forEach(el => el.textContent = cart.item_count);
      updateFreeShipBar(cart);
      const sections = await fetch('/cart?section_id=cart-drawer').then(r => r.text()).catch(() => null);
      if (sections && drawer) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections, 'text/html');
        const newBody = doc.querySelector('.bu-cart-drawer__body');
        const newFoot = doc.querySelector('.bu-cart-drawer__foot');
        if (newBody) drawer.querySelector('.bu-cart-drawer__body').innerHTML = newBody.innerHTML;
        if (newFoot) drawer.querySelector('.bu-cart-drawer__foot').innerHTML = newFoot.innerHTML;
      }
    } catch (err) { console.error('cart refresh', err); }
  }

  function updateFreeShipBar(cart) {
    document.querySelectorAll('[data-bu-free-ship]').forEach(bar => {
      const threshold = parseFloat(bar.dataset.threshold) * 100;
      const total = cart.total_price;
      const pct = Math.min(100, (total / threshold) * 100);
      bar.dataset.unlocked = String(total >= threshold);
      bar.querySelector('.bu-free-ship__fill').style.width = pct + '%';
      const label = bar.querySelector('[data-bu-free-ship-label]');
      if (label) {
        const remaining = ((threshold - total) / 100).toFixed(2);
        label.textContent = total >= threshold
          ? '✓ Free shipping unlocked'
          : `Add $${remaining} for free shipping`;
      }
    });
  }

  /* Sticky buy bar */
  const stickyBar = document.querySelector('[data-bu-sticky-bar]');
  if (stickyBar) {
    let t;
    window.addEventListener('scroll', () => {
      if (t) return;
      t = requestAnimationFrame(() => {
        stickyBar.dataset.visible = String(window.scrollY > 720);
        t = null;
      });
    }, { passive: true });
    stickyBar.querySelector('[data-bu-sticky-dismiss]')?.addEventListener('click', () => {
      stickyBar.remove();
      try { sessionStorage.setItem('bu_sticky_dismissed', '1'); } catch (e) {}
    });
    try { if (sessionStorage.getItem('bu_sticky_dismissed')) stickyBar.remove(); } catch (e) {}
  }

  /* Line-item qty & remove in cart drawer */
  document.addEventListener('click', async (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    const removeBtn = target.closest('[data-bu-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.lineKey, quantity: 0 }),
      });
      await refreshCartUI();
    }
    const qtyBtn = target.closest('[data-bu-line-qty]');
    if (qtyBtn) {
      const delta = parseInt(qtyBtn.dataset.delta, 10);
      const currentEl = qtyBtn.parentElement.querySelector('[data-bu-line-qty-value]');
      const newQty = Math.max(1, parseInt(currentEl?.textContent || '1', 10) + delta);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: qtyBtn.dataset.lineKey, quantity: newQty }),
      });
      await refreshCartUI();
    }
  });
})();
